/**
 * @module ConditionalWrapper
 * @description
 */
import React, { FC } from 'react';

interface Props {
  condition: boolean;
  children: string | JSX.Element;
  wrapper: any;
}

export const ConditionalWrapper: FC<Props> = ( { condition, wrapper, children } ) => condition ? wrapper( children ) : children;

ConditionalWrapper.displayName = 'ConditionalWrapper';

export default ConditionalWrapper;
